/**
 * Normalizes the LgySelectField to change the default "- Select -" value to null
 * @param value - The value of the field on which you have placed the normalizer
 * @param previousValue - The value of the field on which you have placed the normalizer before the most recent change
 * @param allValues - All the values in the form, with the current field value set
 * @param previousAllValues - All the values in the form before the current field is changed
 * @see https://redux-form.com/7.4.2/examples/normalizing/
 * @see https://designsystem.digital.gov/components/form-controls/#dropdown
 */

const normalizeLgySelectField = (value) =>  value === '' ? null : value

export default normalizeLgySelectField